<template>
	<nav :class="{'scroll-action':scroll.y && scroll.top && scroll.y >= scroll.top-30 }">
		<div class="container">
			<div class="flex-grow-1 logo-container">
				<router-link to="/" aria-label="CoproPrivée" class="d-block" @click.native="gtag('click', 'logo','header')">
					<pic :sources="['/img/logo.webp', '/img/logo.png']" alt="CoproPrivée - Logo" class="logo-nav" />
				</router-link>
			</div>
			<div class="d-flex btns">
				<download-btn icon="building"
											:text="['Inscrire ma','Copropriété']"
											:textxs="['Inscrire ma','Copropriété']"
											:to="{name:'devis'}"
											classes="primary" />
<!--				<download-btn icon="calendar-plus"-->
<!--											:to="{name:'demo'}"-->
<!--											:text="['Planifier une','Démonstration']"-->
<!--											classes="primary" />-->
<!--				<download-btn icon="user"-->
<!--											:to="env.VUE_APP_INTERFACE_SIGN_UP"-->
<!--											target="_blank"-->
<!--											:text="['Créer','Mon compte']"-->
<!--											classes="primary" />-->
			</div>
		</div>
	</nav>
</template>
<style lang="scss" scoped>
	nav{
		position: fixed;
		top:-100px;
		left:0;
		right: 0;
		z-index: 10;

		-webkit-transition:all 0.5s ease-in-out;
		-moz-transition:all 0.5s ease-in-out;
		-o-transition:all 0.5s ease-in-out;
		-ms-transition:all 0.5s ease-in-out;
		transition:all 0.5s ease-in-out;

		background: linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);

		-webkit-backdrop-filter: blur(1px);
		backdrop-filter: blur(1px);

		&.scroll-action {
			-webkit-transform: translateY(100px);
			-moz-transform: translateY(100px);
			-ms-transform: translateY(100px);
			transform: translateY(100px);
		}

		>div{
			padding-top: 15px;
			padding-bottom: 15px;
			display: flex;
		}

		.logo-container{
			.logo-nav{
				padding-right: 15px;
				max-width: 210px;
				min-height: 0;
				display: block;
			}
			display: flex;
			flex-direction: column;
			&:before,
			&:after{
				content:'';
				flex-grow: 1;
			}
		}
	}
</style>
<script>
	export default{
		name:'Navh',
	}
</script>
